import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BasicInfo from "@/components/apps/BasicInfo";
import AgendaTable from "@/components/apps/AgendaTable";
import SpeechToText from "@/components/apps/SpeechToText";
import SiteBar from "@/components/apps/SiteBar";
import SpeakerModal from "@/components/apps/SpeakerModal";
import ThemeModal from "@/components/apps/ThemeModal";
import TaskModal from "@/components/apps/TaskModal";
import TagModal from "@/components/apps/TagModal";
import CopyTextModal from "@/components/apps/CopyTextModal";
import CheckBeforeUpdate from "@/components/apps/CheckBeforeUpdate";

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import './assets/reset.css'; 
import './assets/default.css'; 
import './assets/commonagd.css'; 
import './assets/css/jquery-ui/jquery-ui.css'; 
import './assets/css/fontawesome/css/all.css'; 

import VueTextareaAutosize from 'vue-textarea-autosize'

import CollapseAction from './plugins/CollapseAction';


const createapp = createApp(App)
createapp.component("BasicInfo", BasicInfo);
createapp.component("AgendaTable", AgendaTable);
createapp.component("SpeechToText", SpeechToText);
createapp.component("SiteBar", SiteBar);
createapp.component("SpeakerModal", SpeakerModal);
createapp.component("ThemeModal", ThemeModal);
createapp.component("TaskModal", TaskModal);
createapp.component("TagModal", TagModal);
createapp.component("CopyTextModal", CopyTextModal);
createapp.component("CheckBeforeUpdate", CheckBeforeUpdate)
createapp.use(store)
createapp.use(router)
createapp.use(BootstrapVue)
createapp.use(IconsPlugin)
createapp.use(VueTextareaAutosize)
createapp.use(CollapseAction)
createapp.mount('#app')
